// eslint-disable-next-line no-restricted-globals
export default Promise;